export const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8001";
export const EASYSOL_API_BASE = process.env.REACT_APP_EASYSOL_API_BASE || "https://localhost:8002";
export const MAPPLS_CLIENT_ID = process.env.REACT_APP_MAPPLS_CLIENT_ID || "";
export const MAPPLS_CLIENT_SECRET = process.env.REACT_APP_MAPPLS_CLIENT_SECRET || "";
export const MAPPLS_TOKEN = process.env.REACT_APP_MAPPLS_TOKEN || "";
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || "BBKLxB799AnDyqOVwbdu4P5qIvTqCMu2UJeHOg7VnT2K6gv0RZ5cmeb42GwEzOm1a_xjeZB-CnXUIHiqh0wuhts";
